export const STEPS = [
  {
    label: "اهلا بك في وفي, ادخل رقم جوالك",
    description: "سوف نقوم بتأكيد رقم جوالك للدخول الي حسابك",
  },
  {
    label: "قم باعداد حسابك",
    description: `من فضلك ادخل اسمك و ارفع صورتك`,
  },
  {
    label: "قم بتحديد رمز الامان",
    description: `سنطلبه منك لتأكيد أي معاملة تقوم بها, هذا المدخل يقبل ارقام فقط`,
  },
  {
    label: "أكد هويتك عبر أبشر",
    description: `قم بتأكيد هويتك الشخصية بسهولة و سرعة`,
  },
];
export const FINISH = "انتهاء";
export const CONTINUE = "متابعة";
export const NAME_INPUT_LABEL = "أدخل اسمك";
export const ABSHER_INPUT_LABEL = "أدخل رقم الهوية الوطنية";

export const ERROR_PHONE_VALIDATION = "رقم الهاتف غير صحيح";
export const ERROR_DUPLICATE_PHONE_NUMBER = "رقم الهاتف موجود مسبقا";
export const ERROR_OTP_VALIDATION = "كود التفعيل غير صحيح";
export const ERROR_PINCODE_VALIDATION = "رمز الامان غير صحيح";
export const ERROR_PROFILE_VALIDATION = "خطأ في البيانات الشخصية";
export const ERROR_ABSHER_VALIDATION = "رقم الهوية الشخصية غير صحيح";

export const CUSTOMER_SERVICE = "خدمة العملاء";
